/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import { Fragment, useEffect, useState } from 'react';

import { LinkBlock } from '../../../../components/common';
import { WizardSummaryParamValueStyled } from './styled/WizardSummaryStyled';
import { IWizardSummaryParam } from './WizardSummary';

const WizardSummaryRow = (props: IWizardSummaryParam) => {
    const [values, setValues] = useState<string[]>([]);
    const [showMore, setShowMore] = useState(false);

    useEffect(() => {
        if (!props.limit || showMore) {
            setValues(props.values);
            return;
        }
        setValues(props.values.slice(0, props.limit));
    }, [props.limit, props.values, showMore]);

    return <Fragment>
        {
            values.map((value, index) => (
                <WizardSummaryParamValueStyled key={value + index}>
                    {value}
                </WizardSummaryParamValueStyled>
            ))
        }
        {
            !!props.limit && props.limit < props.values.length && <LinkBlock inner onClick={(e) => {
                e.preventDefault();
                setShowMore(!showMore);
            }}>
                {showMore ? props.limitLess : props.limitMore}
            </LinkBlock>
        }
    </Fragment>
};

export default WizardSummaryRow;
